import { Input } from "antd";
import PropTypes from "prop-types";

import classnames from "classnames";
import { useState } from "react";
import Label from "shared/components/Label";

const Custom = ({
  label,
  placeholder,
  errors,
  touched,
  icon,
  innerRef,
  required,
  direction,
  optional,
  right,
  trim = false,
  uppercase = false,
  onChange = () => {},
  ...rest
}) => {
  const [val, setVal] = useState(rest?.defaultValue || rest?.value);
  return (
    <div
      className={classnames(
        "input__wrapper",
        { __error: touched && errors },
        direction,
      )}
    >
      <Label
        label={label}
        icon={icon}
        required={required}
        optional={optional}
        right={right}
      />
      <div className={`input__wrapper--field`}>
        <Input
          value={val}
          className={classnames({
            "input--borderd--red": touched && errors,
            "disable--input": rest.disabled,
          })}
          placeholder={placeholder}
          ref={innerRef}
          onChange={(e) => {
            let value = e.target.value || "";
            if (trim) value = value.replace(/[^a-z0-9]/gi, "");
            if (uppercase) value = value.toUpperCase();
            e.target.value = value;
            setVal(value);
            onChange(e);
          }}
          {...rest}
        />
        {touched && errors && <p className={"input--errors"}>{errors}</p>}
      </div>
    </div>
  );
};

Custom.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
};

Custom.defaultProps = {
  label: "",
  placeholder: "",
};
export default Custom;
